import Network from './network';

const ACTION_TOKENS = 'APi/ActionTokens';

export const GetActionToken = async (id, token, cancelToken) => {
  var headers = { token };
  var url = `${ACTION_TOKENS}/${id}`;
  const resp = await Network.Get(url, null, cancelToken, headers);
  return resp.data;
};